import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Notkunarskilmálar">
            <p>
                Eftirfarandi skilmálar eiga við um vörur og þjónustu 1819, þ.m.t. skráningu og
                miðlun upplýsinga um einstaklinga og fyrirtæki.
            </p>
            <p>
                Með því að kaupa vörur eða nýta þjónustu 1819, þ.m.t. með því að hringja í 1819,
                nota 1819 appið eða fara á heimasíðuna www.1819.is, samþykkir þú, sem notandi, efni
                skilmálanna.
            </p>
            <p>
                <strong>Notkun og skráningar á 1819.</strong>
            </p>
            <p>
                Öllum einstaklingum og lögaðilum er heimilt að skrá sig sem notanda á vefinn
                1819.is. Allar innskráningar inn á vef 1819, skráningar á vefsíðu 1819.is og
                breytingar á skráningu, eiga ávallt að vera staðfestar með Íslykli Þjóðskrár
                Íslands, með rafrænum skilríkjum eða eftir staðfestingarleið þar sem hægt er að
                staðfesta að réttur notandi á við. Með þessu vill 1819 tryggja að það sé rétthafi,
                þ.e. handhafi símanúmers sem framkvæmi skráningu, og til að tryggja rekjanleika við
                skráningu og breytingar. Óheimilt er að framkvæma skráningu, hvort heldur sem er
                skráning á grunnupplýsingum eða viðbótarupplýsingum, ef sá sem framkvæmir skráningu
                er ekki rétthafi viðkomandi upplýsinga.
            </p>
            <p>
                Því til viðbótar er aðilum heimilt að skrá, eða uppfæra, grunnupplýsingar eða
                viðbótarupplýsingar.
            </p>
            <p>
                Rétthafar símanúmera sem eru í símaskrá bera sjálfir ábyrgð á því að réttar
                upplýsingar um þá séu skráðar á miðlum 1819. Rétthafar skrá sig inn með rafrænum
                skilríkum eða með Íslykli inná innskráningarvef www.1819.is
            </p>
            <p>
                1819 &aacute;skilur s&eacute;r r&eacute;tt til a&eth; ey&eth;a &uacute;t
                skr&aacute;ningu ef h&uacute;n br&yacute;tur &iacute; b&aacute;ga vi&eth;
                skilm&aacute;la &thorn;essa e&eth;a ef 1819 telur a&eth; skr&aacute;ningin
                samr&aelig;mist ekki l&ouml;gum. Skr&aacute;ning er &aacute;vallt &aacute;
                &aacute;byrg&eth; &thorn;ess a&eth;ila sem skr&aacute;ir. 1819 ber a&eth;
                uppl&yacute;sa um gildandi gjaldskr&aacute; &aacute; vefnum.
            </p>
            <p>
                &Oacute;heimilt er a&eth; skr&aacute; s&ouml;mu skr&aacute;ninguna oftar en einu
                sinni og notanda er a&eth;eins heimilt a&eth; nota sinn a&eth;gang. Notanda er
                einnig &oacute;heimilt a&eth; gefa upp notandanafn og lykilor&eth; til
                &thorn;ri&eth;ja a&eth;ila.&nbsp;
            </p>
            <p>
                <strong>H&ouml;fundarr&eacute;ttur 1819, kortavefur og gagnagrunnur.</strong>
            </p>
            <p>
                1819 &aacute; h&ouml;fundarr&eacute;ttinn af &ouml;llum &thorn;eim
                uppl&yacute;singum og g&ouml;gnum sem fram koma &aacute; vef 1819, nema anna&eth;
                s&eacute; s&eacute;rstaklega teki&eth; fram e&eth;a lei&eth;a megi af e&eth;li
                m&aacute;ls. Skriflegt sam&thorn;ykki 1819 &thorn;arf til a&eth; endurbirta
                uppl&yacute;singar sem fram koma &aacute; vef 1819, dreifa &thorn;eim e&eth;a afrita
                &thorn;&aelig;r, &iacute; heild e&eth;a hluta, hvort heldur sem er me&eth;
                skj&aacute;myndum, prentun e&eth;a &aacute; annan samb&aelig;rilegan h&aacute;tt.
                Ekki skiptir m&aacute;li hvers e&eth;lis umr&aelig;ddar uppl&yacute;singar eru
                n&eacute; &iacute; hva&eth;a tilgangi &aelig;tlunin er a&eth; endurbirta
                &thorn;&aelig;r, afrita e&eth;a dreifa. &Iacute; &thorn;v&iacute; felst m.a. a&eth;
                &oacute;heimilt er &aacute;n skriflegs leyfi 1819 a&eth; (a) afrita, breyta, dreifa,
                leigja, l&aacute;na, selja, marka&eth;ssetja, gefa &uacute;t e&eth;a framlei&eth;a
                nokkurt efni sem byggir &aacute; efni 1819, &thorn;.m.t. gagnagrunni e&eth;a
                kortavef, (b) afk&oacute;&eth;a, e&eth;a &aacute; annan h&aacute;tt reyna a&eth;
                komast a&eth; frumk&oacute;&eth;a gagnagrunns 1819, &thorn;.m.t. gagnagrunn og
                kortavef, a&eth; hluta e&eth;a &iacute; heild, til samn&yacute;tingar me&eth;
                &ouml;&eth;rum v&ouml;rum e&eth;a forritum, &thorn;.m.t.
                lei&eth;s&ouml;gut&aelig;kjum og sm&aacute;forritum e&eth;a (e) nota
                uppl&yacute;singar 1819, &thorn;.m.t. gagnagrunn og kortavef 1819, til a&eth;
                &uacute;tb&uacute;a gagnagrunna, t.d. af st&ouml;&eth;um e&eth;a &ouml;&eth;rum
                skr&aacute;ningum.
            </p>
            <p>Kort &aacute; kortavef 1819 eru &iacute; eigu Mapbox</p>
            <p>
                Me&eth; notkun &aacute; kortavef 1819 &aacute; vefsv&aelig;&eth;i 1819.is
                sam&thorn;ykkir notandi skilm&aacute;la &thorn;essa og skilm&aacute;la Mapbox, sem
                og hugverkar&eacute;tt Mapbox. Innihald kortanna er byggt &aacute; n&aacute;nar
                tilgreindum gagnas&ouml;fnum sem kunna a&eth; vera &iacute; eigu &thorn;ri&eth;ja
                a&eth;ila.
            </p>
            <p>
                Allur r&eacute;ttur a&eth; &thorn;j&oacute;nustu kortavefs 1819 er &aacute;skilinn
                1819 og eignarr&eacute;ttur a&eth; tilgreindum gagnas&ouml;fnum er &iacute; eigu
                ofangreindra a&eth;ila en h&ouml;fundar- og eignarr&eacute;ttur kortavefs 1819 er
                &iacute; eigu 1819, nema anna&eth; s&eacute; teki&eth; fram.
            </p>
            <p>
                <strong>Breytingar &aacute; skilm&aacute;lum.</strong>
            </p>
            <p>
                1819 &aacute;skilur s&eacute;r r&eacute;tt til a&eth; &aacute;kvar&eth;a
                einhli&eth;a &thorn;j&oacute;nustu 1819 og breyta skilm&aacute;lum &aacute;n
                fyrirvara. Eru notendur 1819 hvattir til &thorn;a&eth; kynna s&eacute;r
                skilm&aacute;lana eins og &thorn;eir eru &aacute; hverjum t&iacute;ma.
            </p>
            <p>
                <strong>Fyrirvarar</strong>
                <strong>.</strong>
            </p>
            <p>
                1819 ber hvorki &aacute;byrg&eth; &aacute; tj&oacute;ni sem rekja m&aacute; beint
                e&eth;a &oacute;beint til notkunar &aacute; vef og appi 1819 n&eacute; tj&oacute;ni
                sem rekja m&aacute; til &thorn;ess a&eth; ekki var h&aelig;gt a&eth; nota vefinn
                e&eth;a appi&eth; um skemmri e&eth;a lengri t&iacute;ma.
            </p>
            <p>
                &THORN;&aacute; ber 1819 ekki &aacute;byrg&eth; &aacute; tj&oacute;ni sem orsakast
                beint e&eth;a &oacute;beint vegna bilunar &iacute; t&ouml;lvub&uacute;na&eth;i
                og/e&eth;a hugb&uacute;na&eth;i 1819 e&eth;a notenda, e&eth;a af &ouml;&eth;rum
                ors&ouml;kum sem kunna a&eth; valda &thorn;v&iacute; a&eth; uppl&yacute;singar
                s&eacute;u ekki r&eacute;ttar e&eth;a notandi n&aacute;i ekki a&eth; tengjast
                &thorn;j&oacute;nustu 1819 hvort sem er &iacute; gegnum vefs&iacute;&eth;u e&eth;a
                app.
            </p>
            <p>
                1819 &aacute;byrgist ekki a&eth; uppl&yacute;singar sem birtast &aacute;{" "}
                <a href="http://www.1819.is/">www.1819.is</a> e&eth;a &iacute; appi, s&eacute;u
                r&eacute;ttar. 1819 &aacute;byrgist ekki efni sem upprunni&eth; er hj&aacute;
                &thorn;ri&eth;ju a&eth;ilum og birt er &aacute; vefnum. 1819 &aacute;skilur
                s&eacute;r r&eacute;tt til &thorn;ess a&eth; breyta innihaldi s&iacute;&eth;unnar
                1819.is og &iacute; appi, &aacute; hva&eth;a h&aacute;tt sem er og hven&aelig;r sem
                er, &iacute; hva&eth;a tilgangi sem er, &aacute;n fyrirfram tilkynningar og tekur
                ekki &aacute;byrg&eth; &aacute; neinum hugsanlegum aflei&eth;ingum sl&iacute;kra
                breytinga. 1819 ber enga &aacute;byrg&eth; &aacute; &oacute;&thorn;&aelig;gindum sem
                notendur &thorn;j&oacute;nustunnar kunna a&eth; ver&eth;a fyrir vi&eth; notkun
                &aacute; v&ouml;rum 1819.
            </p>
        </InfoSection>
    );
}
export default ServiceNumber;
